<script setup>

import {storeToRefs} from "pinia";
import {useUserConnectStore} from "@/stores/userConnect.store";
import {showConfirmDialog} from "vant";

const userConnectStore = useUserConnectStore();
userConnectStore.fetchAll();
const {userConnects, type, search} = storeToRefs(userConnectStore);

const doSearch = async () => {
    userConnectStore.fetchAll();
}

const updateType = (type) => {
    userConnectStore.type = type;
    if (type === '') {
        userConnectStore.type = '';
    }
    userConnectStore.fetchAll();
}

const doDelete = (id) => {
    showConfirmDialog({
        title: 'Notice',
        message: 'Do you want to delete this entry?',
    }).then(() => {
        userConnectStore.deleteOne(id);
        doSearch();
    });
}

</script>

<template>
    <van-space direction="vertical" fill>
        <van-search v-model="search" @search="doSearch" @cancel="doSearch" placeholder="Search for your connects"/>
        <van-grid clickable :column-num="5">
            <van-grid-item icon="filter-o" text="All" :dot="type === ''" @click="updateType('')"/>
            <van-grid-item icon="logistics" text="Emergency" :dot="type === 'emergency'"
                           @click="updateType('emergency')"/>
            <van-grid-item icon="user-circle-o" text="Sponsor" :dot="type === 'sponsor'"
                           @click="updateType('sponsor')"/>
            <van-grid-item icon="contact" text="Counselors" :dot="type === 'counselor'"
                           @click="updateType('counselor')"/>
            <van-grid-item icon="friends-o" text="Friends" :dot="type === 'friend'" @click="updateType('friend')"/>
        </van-grid>

        <div v-if="userConnects.length === 0">
            <van-empty image="search" description="Nothing found"/>
        </div>
        <div v-if="userConnects.length > 0">
            <van-cell-group inset
                            v-for="userConnect in userConnects" :key="userConnect.id">
                <van-cell is-link :to="'/connect/' + userConnect.id">
                    <template #title>
                        <b>{{ userConnect.full_name }}</b>
                    </template>
                </van-cell>
                <van-cell title="Phone" :value="userConnect.phone"/>
                <van-cell title="Type" :value="userConnect.type"/>
                <van-cell title="Default" :value="userConnect.default_connect"/>
                <van-cell title="Created" title-class="" :value="userConnect.created_at_formatted"/>
                <van-cell center title="Action">
                    <van-button icon="delete-o" size="mini" plain type="danger" @click="doDelete(userConnect.id)"/>
                </van-cell>
                <van-row>&nbsp;</van-row>
            </van-cell-group>
        </div>

        <van-cell-group inset>
            <van-button block round type="success" to="/connect/0">
                New Connect
            </van-button>
        </van-cell-group>
    </van-space>
</template>

<style>

:root:root {
    --van-grid-item-text-font-size: var(--van-font-size-xs);
    --van-sidebar-width: 110px;
}

</style>
